import { useMembership } from '@ocx/data-membership';
import { ScreenLoaderBackdrop } from '@ocx/ui';

import { useCreateLoyaltyEventWithStatusModal } from '../../../modules/events/hooks/useCreateLoyaltyEventWithStatusModal';

export const LoyaltyEventBackdropController = () => {
  const { membership } = useMembership();
  const { loading } = useCreateLoyaltyEventWithStatusModal({
    membershipId: membership.id,
  });

  return <ScreenLoaderBackdrop open={loading} />;
};
